export default "__VITE_ASSET__CBn3psPe__"